import React, { useContext, useEffect } from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import { Box, Button, Divider, Stack } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MdDeleteForever, MdFileDownload, MdVisibility } from 'react-icons/md';
import { IconButton, FileInfo } from './styled';
import { ReverseCollectContext } from '../../../..';
import { contentDeclaration } from '../../../../../../reports/contentDeclaration';

export const Declaration = () => {
  const maxXS = useMediaQuery('(max-width:480px)');

  const {
    fileAmount,
    declarationFiles,
    openCreateDeclarationModal,
    openRemoveDeclarationModal
  } = useContext(ReverseCollectContext);

  const handleOpenDeclaration = (id) => {
    const indexFile = declarationFiles.findIndex((file) => file.id === id);

    const { senderData, recipientData, commodityList } =
      declarationFiles[indexFile];

    pdfMake
      .createPdf(
        contentDeclaration({ senderData, recipientData, commodityList })
      )
      .open();
  };

  const handleDownloadDeclaration = (id) => {
    const indexFile = declarationFiles.findIndex((file) => file.id === id);

    const { senderData, recipientData, commodityList } =
      declarationFiles[indexFile];

    pdfMake
      .createPdf(
        contentDeclaration({ senderData, recipientData, commodityList })
      )
      .download('declaracao');
  };

  return (
    <Stack spacing={2} style={{ width: '100%', alignItems: 'flex-start' }}>
      {declarationFiles.length > 0 && (
        <>
          <p style={{ fontWeight: 'bold' }}>Declaração preenchida: </p>
          <Stack
            gap={2}
            style={{ width: '100%' }}
            divider={<Divider orientation="horizontal" flexItem />}
          >
            {declarationFiles.map(({ id, name, readableSize }) => (
              <Box
                key={id}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <FileInfo>
                  <strong
                    style={{
                      width: maxXS && 140,
                      textOverflow: maxXS && 'ellipsis',
                      overflow: maxXS && 'hidden',
                      whiteSpace: maxXS && 'nowrap'
                    }}
                  >
                    {name}
                  </strong>
                  <span>{readableSize}</span>
                </FileInfo>

                <Stack direction="row" gap={1}>
                  <IconButton
                    type="button"
                    onClick={() => handleOpenDeclaration(id)}
                  >
                    <MdVisibility size={20} />
                  </IconButton>

                  <IconButton
                    type="button"
                    onClick={() => handleDownloadDeclaration(id)}
                  >
                    <MdFileDownload size={20} />
                  </IconButton>

                  <IconButton
                    type="button"
                    onClick={() => openRemoveDeclarationModal(id)}
                  >
                    <MdDeleteForever size={20} />
                  </IconButton>
                </Stack>
              </Box>
            ))}
          </Stack>
        </>
      )}

      {declarationFiles.length < fileAmount && (
        <Button
          variant="outlined"
          color="secondary"
          type="button"
          style={{ fontSize: '14px', fontWeight: 'normal' }}
          onClick={openCreateDeclarationModal}
        >
          Preencher nova declaração
        </Button>
      )}
    </Stack>
  );
};
